module.exports = __webpack_public_path__ + "static/media/slide03.81b4980f.jpg";